import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function ReparerPlutot() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/f8da0e25dd5d930c14e6a08c7a560221.jpeg" alt="Diagnostic avant réparation de volet roulant à Strasbourg" className="w-full h-[400px] md:h-[500px]" loading="lazy" />
          </div>
          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-4">
              Réparer plutôt que remplacer
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Dans la grande majorité des cas, la réparation suffit à remettre votre volet roulant en parfait état de fonctionnement. Un moteur qui ne répond plus, une sangle cassée ou un tablier endommagé ne signifient pas qu'il faut changer l'ensemble du volet. Nos techniciens commencent toujours par un diagnostic complet sur place pour identifier la pièce exacte à remplacer. Ils privilégient la solution la plus économique et la plus durable pour vous : réparer d'abord, remplacer si nécessaire. Cette approche vous fait gagner du temps et de l'argent, tout en préservant votre habitat.
            </p>
            <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
              <h3 className="text-brand-blue text-lg font-bold mb-2">Diagnostic gratuit</h3>
              <p className="text-brand-text text-sm leading-relaxed mb-5">
                Nous inspectons votre volet sur place et vous proposons la solution la plus adaptée à votre budget.
              </p>
              <a
                href="tel:0374473240"
                className="flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-3 rounded-full font-semibold text-sm hover:bg-brand-cyan/90 transition-all duration-200 btn-hover-effect whitespace-nowrap mx-auto"
              >
                <span className="btn-icon-wrap"><i className="ri-phone-line text-base"></i></span>
                Appeler le 03 74 47 32 40
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}